module.exports = __webpack_public_path__ + "img/penguin_bowtie.f098f327.svg";